import http from "./http-common";
class WebDataService {
  sendUserAgent(
    content_id,
    category,
    country_name,
    country_code,
    city,
    state,
    latitude,
    longitude,
    IPv4
  ) {
    const formData = {
      content_id: content_id,
      category: category,
      country_name: country_name,
      country_code: country_code,
      city: city,
      state: state,
      latitude: latitude,
      longitude: longitude,
      IPv4: IPv4,
    };
    return http.post("/add-visitor", formData);
    
  }
}
export default new WebDataService();
